import * as Sentry from '@sentry/nuxt'

const dsn = useRuntimeConfig().public.sentryDsnTcf

if (dsn) {
  Sentry.init({
    dsn,
    debug: process.env.NODE_ENV !== 'production',
    environment: process.env.NODE_ENV || 'production',

    // 1. Quota & Sampling Optimization
    tracesSampleRate: 0.1, // Sample 10% of transactions for performance monitoring
    replaysSessionSampleRate: 0, // Disable regular session recoarding to conserve quota
    replaysOnErrorSampleRate: 1.0, // Record 100% of sessions when an error occurs (lower to 0.5 under high traffic)

    // 2. PII Protection & Payload Optimization
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],

    // 3. Filter Out Common Browser & Extension Noise
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Network Error',
      'Failed to fetch',
      'Load failed',
      'Importing a module script failed',
      'User rejected the request',
      'top.GLOBALS',
      'originalCreateNotification',
    ],
  })
} else {
  console.warn('⚠️ Sentry Client: Missing public.sentryDsnTcf configuration')
}
